module.exports = __webpack_public_path__ + "static/ey-6-sq-afb8363a98222d6a12c373bdd42b1086.png";